import 'Styles/templates/blog.scss';

import LazyVideo from '../components/lazy-video';
import BlogGrid from '../vue/blog/blog-grid';
import BlogSlider from '../vue/blog/blog-slider';
import TopStories from '../vue/blog/top-stories';

LazyVideo();
BlogGrid();
BlogSlider();
TopStories();